import TimepickerLocale from 'rc-time-picker/lib/locale/zh_CN';

const locale = {
  placeholder: '请选择时间',
  ... TimepickerLocale,
};

export default locale;



/** WEBPACK FOOTER **
 ** ./components/time-picker/locale/zh_CN.js
 **/